import {
  ADD_COHORT_REPORTS,
  CHANGE_COHORT_REPORTS_TEMPLATE,
  DELETE_COHORT_REPORTS,
  DOWNLOAD_COHORT_REPORTS_DATA,
  INIT_COHORT_REPORTS,
  GET_COHORT_REPORTS_LIST,
  GET_COHORT_REPORTS_OPTIONS,
  GET_COHORT_REPORTS_PARAMS_FOR_FRAGMENTATION,
  GET_COHORT_REPORTS_PROFILE,
  GET_COHORT_REPORTS_TEMPLATES,
  HIDE_COHORT_REPORTS_LIST_LOADER,
  HIDE_COHORT_REPORTS_OPTIONS_LOADER,
  HIDE_COHORT_REPORTS_PARAMS_FOR_FRAGMENTATION_LOADER,
  PATCH_COHORT_REPORTS_COHORT_SETUP,
  SET_COHORT_REPORTS_COHORT_SETUP,
  SET_COHORT_REPORTS_LIST,
  SET_COHORT_REPORTS_OPTIONS,
  SET_COHORT_REPORTS_PARAMS_FOR_FRAGMENTATION,
  SET_COHORT_REPORTS_PROFILE,
  SET_COHORT_REPORTS_SHOW_FILTER,
  SET_COHORT_REPORTS_TEMPLATE,
  SET_COHORT_REPORTS_TEMPLATES,
  SET_ERROR_COHORT_REPORTS_PROFILE,
  SHOW_COHORT_REPORTS_LIST_LOADER,
  SHOW_COHORT_REPORTS_OPTIONS_LOADER,
  SHOW_COHORT_REPORTS_PARAMS_FOR_FRAGMENTATION_LOADER,
  UPDATE_COHORT_REPORTS_PROFILE,
  SAVE_COHORT_REPORTS_TEMPLATE,
  CREATE_COHORT_REPORTS_TEMPLATE,
  DELETE_COHORT_REPORTS_TEMPLATE, SET_INIT_COHORT_REPORTS_STATE
} from "./actionTypes"

export const initCohortReport = (data, parsed_query) => ({
  type: INIT_COHORT_REPORTS,
  payload: { data, parsed_query }
})

export const setInitCohortReportState = () => ({
  type: SET_INIT_COHORT_REPORTS_STATE
})

export const getCohortReportList = data => ({
  type: GET_COHORT_REPORTS_LIST,
  payload: data
})

export const setCohortReportList = payload => ({
  type: SET_COHORT_REPORTS_LIST,
  payload
})

export const showCohortReportListLoader = () => ({
  type: SHOW_COHORT_REPORTS_LIST_LOADER
})

export const hideCohortReportListLoader = () => ({
  type: HIDE_COHORT_REPORTS_LIST_LOADER
})

export const addCohortReport = (COHORT_REPORTS = {}, data = {}) => ({
  type: ADD_COHORT_REPORTS,
  payload: { COHORT_REPORTS, data }
})

export const deleteCohortReport = (id, data = {}) => ({
  type: DELETE_COHORT_REPORTS,
  payload: { id, data }
})

export const getCohortReportProfile = id => ({
  type: GET_COHORT_REPORTS_PROFILE,
  payload: id
})

export const setCohortReportProfile = payload => ({
  type: SET_COHORT_REPORTS_PROFILE,
  payload
})

export const updateCohortReportProfile = (id, COHORT_REPORTS = {}, data = {}) => ({
  type: UPDATE_COHORT_REPORTS_PROFILE,
  payload: { id, COHORT_REPORTS, data }
})

export const setErrorCohortReportProfile = payload => ({
  type: SET_ERROR_COHORT_REPORTS_PROFILE,
  payload
})

/* OPTIONS */
export const getCohortReportOptions = payload => ({
  type: GET_COHORT_REPORTS_OPTIONS,
  payload
})

export const setCohortReportOptions = payload => ({
  type: SET_COHORT_REPORTS_OPTIONS,
  payload
})

export const setCohortReportShowFilter = payload => ({
  type: SET_COHORT_REPORTS_SHOW_FILTER,
  payload
})

export const showCohortReportOptionsLoader = () => ({
  type: SHOW_COHORT_REPORTS_OPTIONS_LOADER
})

export const hideCohortReportOptionsLoader = () => ({
  type: HIDE_COHORT_REPORTS_OPTIONS_LOADER
})

/* PARAMS FOR FRAGMENTATION */
export const getCohortReportParamsForFragmentation = payload => ({
  type: GET_COHORT_REPORTS_PARAMS_FOR_FRAGMENTATION,
  payload
})

export const setCohortReportParamsForFragmentation = payload => ({
  type: SET_COHORT_REPORTS_PARAMS_FOR_FRAGMENTATION,
  payload
})

export const showCohortReportParamsForFragmentationLoader = () => ({
  type: SHOW_COHORT_REPORTS_PARAMS_FOR_FRAGMENTATION_LOADER
})

export const hideCohortReportParamsForFragmentationLoader = () => ({
  type: HIDE_COHORT_REPORTS_PARAMS_FOR_FRAGMENTATION_LOADER
})

/* COHORT SETUP */

export const setCohortReportCohortSetup = payload => ({
  type: SET_COHORT_REPORTS_COHORT_SETUP,
  payload
})

export const patchCohortReportCohortSetup = (params, callback) => ({
  type: PATCH_COHORT_REPORTS_COHORT_SETUP,
  payload: { params, callback }
})

export const downloadCohortReportData = () => ({
  type: DOWNLOAD_COHORT_REPORTS_DATA
})

export const getCohortReportTemplates = payload => ({
  type: GET_COHORT_REPORTS_TEMPLATES,
  payload
})

export const changeCohortReportTemplate = payload => ({
  type: CHANGE_COHORT_REPORTS_TEMPLATE,
  payload
})

export const setCohortReportTemplates = payload => ({
  type: SET_COHORT_REPORTS_TEMPLATES,
  payload
})

export const saveCohortReportTemplate = payload => ({
  type: SAVE_COHORT_REPORTS_TEMPLATE,
  payload
})

export const deleteCohortReportTemplate = payload => ({
  type: DELETE_COHORT_REPORTS_TEMPLATE,
  payload
})

export const createCohortReportTemplate = payload => ({
  type: CREATE_COHORT_REPORTS_TEMPLATE,
  payload
})

export const setCohortReportTemplate = payload => ({
  type: SET_COHORT_REPORTS_TEMPLATE,
  payload
})


